/* eslint-disable react/no-unknown-property */
/* eslint-disable max-len */
import React from 'react';

/**
 * ReportIssueIcon - Auto-generated from icon.js
 */
export const ReportIssueIcon = (props: React.SVGProps<SVGSVGElement>): JSX.Element => (
	<svg width="18" height="19" viewBox="0 0 18 19" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
		<g id="Group 2164">
			<path id="Rectangle 3190" d="M3.5 6.90625C3.5 6.07782 4.17157 5.40625 5 5.40625H13C13.8284 5.40625 14.5 6.07782 14.5 6.90625V12.9062C14.5 15.9438 12.0376 18.4062 9 18.4062C5.96243 18.4062 3.5 15.9438 3.5 12.9062V6.90625Z" stroke="#676767" />
			<path id="Rectangle 3191" d="M12.375 5.5V4.375C12.375 2.51104 10.864 1 9 1V1C7.13604 1 5.625 2.51104 5.625 4.375V5.5" stroke="#676767" />
			<path id="Vector 86" d="M0 12.125H3.375" stroke="#676767" />
			<path id="Vector 87" d="M14.625 12.125H18" stroke="#676767" />
			<path id="Vector 81" d="M9 5.5L9 12.25" stroke="#676767" />
			<path id="Vector 84" d="M1.125 18.3125L3.9375 15.5" stroke="#676767" />
			<path id="Vector 85" d="M16.875 18.3125L14.0625 15.5" stroke="#676767" />
		</g>
	</svg>
);

export default ReportIssueIcon;
